module.exports = __webpack_public_path__ + "static/media/point+12.6e7a1195.png";